import React, { forwardRef, useMemo } from 'react';
import PropTypes from 'prop-types';
import cs from 'classnames';
import './index.external.css';

function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.indexOf(n) >= 0) continue;
    t[n] = r[n];
  }
  return t;
}

var styles = {"breadcrumbs":"breadcrumbs-136e4","breadcrumb":"breadcrumb-136e4","linkContent":"linkContent-136e4","arrowIcon":"arrowIcon-136e4","arrowIconLeft":"arrowIconLeft-136e4"};

var _excluded = ["className", "seoItems", "ariaLabel", "renderSEOToHead", "children"];
var getSeoContentFromItems = items => {
  if (!items) {
    return '';
  }
  var seoBreadcrumbStructuredData = {
    '@context': 'https://schema.org/',
    '@type': 'BreadcrumbList',
    itemListElement: []
  };
  seoBreadcrumbStructuredData.itemListElement = items.map((item, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    item: {
      '@id': item.url,
      name: item.label
    }
  }));
  return JSON.stringify(seoBreadcrumbStructuredData);
};
var Breadcrumbs = /*#__PURE__*/forwardRef((_ref, ref) => {
  var {
      className,
      seoItems,
      ariaLabel,
      renderSEOToHead,
      children
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var seoContent = useMemo(() => getSeoContentFromItems(seoItems), [seoItems]);
  var headContent = renderSEOToHead(seoContent);
  return /*#__PURE__*/React.createElement(React.Fragment, null, headContent, /*#__PURE__*/React.createElement("nav", {
    "aria-label": ariaLabel,
    "data-lll-pl": "breadcrumbs"
  }, /*#__PURE__*/React.createElement("ul", _extends({
    ref: ref,
    className: cs(styles.breadcrumbs, className)
  }, otherProps), React.Children.map(children, (child, index) => /*#__PURE__*/React.createElement("li", _extends({
    "data-testid": "breadcrumb-li"
  }, index < children.length - 1 && {
    'data-slash': '/'
  }, {
    className: styles.breadcrumb
    // eslint-disable-next-line react/no-array-index-key
    ,
    key: index
  }), child)))));
});
var propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  renderSEOToHead: PropTypes.func.isRequired,
  ariaLabel: PropTypes.string,
  seoItems: PropTypes.arrayOf(PropTypes.shape({
    url: PropTypes.string,
    label: PropTypes.string
  }))
};
var defaultProps = {
  className: '',
  ariaLabel: 'Breadcrumb',
  seoItems: [{
    url: '',
    label: ''
  }]
};
Breadcrumbs.propTypes = propTypes;
Breadcrumbs.defaultProps = defaultProps;

export { Breadcrumbs, defaultProps, propTypes };
//# sourceMappingURL=index.js.map
